<template>
  <div class="feed-header">
    <div class="p-1">
      <div class="feed-header__top d-flex w-100">
        <div
          class="feed-header__subscribers-list d-flex align-items-center"
          data-cy="page-schedule-subscriber-list"
        >
          <div
            class="feed-header__subscribers-wrapper"
            @click="handleShowParticipants"
          >
            <subscriber-avatars
              class="feed-header__subscriber-avatars"
              :subscribers="
                subscriberAvatars.slice(0, LIMIT_SHOWN_SUBSCRIBER_AVATAR)
              "
              small
            />
          </div>
          <share>
            <v-button rounded primary>{{
              $t("components.messageThread.feedHeader.invite")
            }}</v-button>
          </share>
        </div>
        <subscribe-button
          :key="messageThreadId"
          :message-thread-id="messageThreadId"
          @enabled="e => $emit('enabled', e)"
        />
      </div>
      <div>
        <active-member
          :member-count="memberCount"
          :participant-count="totalParticipantCount"
        />
      </div>
    </div>

    <thread-participants-modal
      v-if="showParticipantsModal"
      with-profile
      :heading="$t('components.messageThread.feedHeader.members')"
      :message-thread-id="messageThreadId"
      @close="closeParticipantModal"
    />
  </div>
</template>

<script>
import ActiveMember from "@/components/message-thread/ActiveMember"
import SubscribeButton from "@/components/message-thread/SubscribeButton"
import Share from "@/components/block-actions/Share"
import { THREAD_MODAL_HASH } from "@/lib/messages-utils"

import ThreadParticipantsModal from "@/components/modals/ThreadParticipantsModal"

export const LIMIT_SHOWN_SUBSCRIBER_AVATAR = 5

export default {
  components: {
    ActiveMember,
    Share,
    SubscribeButton,
    ThreadParticipantsModal,
    SubscriberAvatars: () => import("@/components/SubscriberAvatars")
  },

  props: {
    subscriberAvatars: { type: Array, default: () => [] },
    messageThreadId: { type: [Number, String], required: true },
    memberCount: { type: [Number, String], required: true },
    totalParticipantCount: { type: Number, default: 0 }
  },

  data() {
    return {
      showParticipantsModal: false,
      LIMIT_SHOWN_SUBSCRIBER_AVATAR
    }
  },

  methods: {
    closeParticipantModal() {
      this.showParticipantsModal = false
      this.$router.removeHash()
    },

    handleShowParticipants() {
      this.showParticipantsModal = true
      this.$router.push(THREAD_MODAL_HASH.PARTICIPANTS)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.feed-header {
  .feed-header__top {
    .feed-header__subscriber-avatars {
      animation: fade-in-up 0.3s ease;
      margin-right: -1.35rem;
    }

    .feed-header__subscribers-list {
      flex-grow: 1;
      cursor: pointer;

      .v-button {
        border: 2px solid $color-ui--white;
      }

      .subscriber-avatar {
        margin-left: -1.35rem;

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
